// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"d2aeb5ad","453":"c9b1eb56"}[chunkId] + ".chunk.js";
};